<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { useAgentAccountStore } from "@/store/agentAccountStore";
import { useAgentStore } from "@/store/agentStore";
import { useWalletStore } from "@/store/walletStore";

import { ref } from "vue";
import Swal from "sweetalert2";

/**
 * Dashboard Component
 */
export default {
  setup() {
    const doesAddOpen = ref(false);
    const doesEditOpen = ref(false);
    const doesDeleteOpen = ref(false);
    const doesLoadingOpen = ref(false);
    const agentAccountStore = useAgentAccountStore();
    const agentStore = useAgentStore();
    const walletStore = useWalletStore();

    return {
      doesAddOpen,
      doesEditOpen,
      doesDeleteOpen,
      doesLoadingOpen,
      agentAccountStore,
      agentStore,
      walletStore,
    };
  },
  page: {
    title: "Pays",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Pays",
      items: [
        {
          text: "Menu",
        },
        {
          text: "Pays",
          active: true,
        },
      ],
      errors: [],
      account: {},
      methods: [],
      agents: [],
      accounts: [],
      wallets: [],
      accountNumbers: [],
      selectedAgentAccounts: [],
      accounts_search: [],

      accountName: "",
      number: "",
      link: "",
      details: "",

      compte: {},
      agent: "",
      method: "",

      account_id: "",
      agent_id: "",
      wallet_id: "",

      loading: false,
      account_status: true,
      search: "",

      status: 201,
      length: 0,
    };
  },
  methods: {
    async loadFromStore() {
      if (!this.agentAccountStore.list) {
        await this.agentAccountStore.loadFromApi(true).then((data) => {
          this.accounts = data;
          this.accounts_search = data;
        });
      } else {
        this.accounts = this.agentAccountStore.list;
        this.accounts_search = this.accounts;
      }

      console.log("accouts", this.accounts);
    },

    async loadAgents() {
      if (!this.agentStore.withAccounts) {
        await this.agentStore.loadWithAccount().then((data) => {
          this.agents = data;
          this.accountNumbers = this.agents.flatMap(
            (agent) => agent.user?.accountNumbers || []
          );
        });
      } else {
        this.agents = this.agentStore.withAccounts;
        this.accountNumbers = this.agents.flatMap(
          (agent) => agent.user?.accountNumbers || []
        );
      }
    },

    async loadWallets() {
      if (!this.walletStore.list) {
        await this.walletStore.loadFromApi().then((data) => {
          this.wallets = data;
        });
      } else {
        this.wallets = this.walletStore.list;
      }
    },

    async refresh() {
      await this.agentAccountStore.loadFromApi().then((data) => {
        this.accounts = data;
        this.accounts_search = data.length;
      });
    },

    addItem() {
      this.errors = [];
      let body = {
        status: this.account_status,
        accountName: this.accountName,
        link: this.link,
        number: this.number,

        agent: {
          id: this.agent_id,
        },
        account: {
          id: this.account_id,
        },
        wallet: {
          id: this.wallet_id,
        },
      };
      this.agentAccountStore.createItem(body);
      this.accounts = this.agentAccountStore.list;
      this.accounts_search = this.accounts;
    },

    editItem() {
      this.errors = [];
      let body = {
        accountName: this.accountName,
        number: this.number,
        link: this.link,
        status: this.status,
        details: this.details,
        agent: {
          id: this.agent_id,
        },
        account: {
          id: this.country_id,
        },
        wallet: {
          id: this.wallet_id,
        },
      };

      if (this.type !== "") {
        body["type"] = this.type;
      }

      this.agentAccountStore.editItem(this.account?.id, body);
      this.accounts = this.agentAccountStore.list;
      this.accounts_search = this.accounts;
    },

    deleteIt() {
      this.agentAccountStore.deleteItem(this.method.id);

      this.accounts = this.agentAccountStore.list;
      this.accounts_search = this.accounts;
    },

    filter_account() {
      this.accounts = this.accounts_search;
      if (this.search != "") {
        this.accounts = this.accounts.filter(
          (user) =>
            user.accountName?.toLowerCase().includes(this.search.toLowerCase()) ||
            user.agent?.user?.lastName
              ?.toLowerCase()
              .includes(this.search.toLowerCase()) ||
            user.agent?.user?.firstName
              ?.toLowerCase()
              .includes(this.search.toLowerCase()) ||
            user.number?.toLowerCase().includes(this.search.toLowerCase())
        );
      }
    },

    async onAddItem() {
      Swal.showLoading(null);
      await Promise.all([this.loadWallets(), this.loadAgents()]);
      Swal.close();
      this.doesAddOpen = true;
    },

    async initItem(account, action = "edit") {
      this.account = account;
      this.initData(account);
      if (action == "delete") {
        this.doesDeleteOpen = true;
      } else {
        Swal.showLoading(null);
        await Promise.all([this.loadWallets(), this.loadAgents()]);
        Swal.close();
        this.doesEditOpen = true;
      }
    },

    initData(item = null) {
      this.status = item != null ? item.status : "";
      this.accountName = item != null ? item.accountName : "";
      this.number = item != null ? item.number : "";
      this.link = item != null ? item.link : "";
      this.agent_id = item != null ? item.idOfAgent : "";
      this.account_id = item != null ? item.idOfAccount : "";
      this.wallet_id = item != null ? item.idOfWallet : "";
      if (this.agent_id) {
        this.updateAccounts();
      }
    },

    updateAccounts() {
      const selectedAgent = this.agents.find((agent) => agent?.id === this.agent_id);
      this.selectedAgentAccounts = selectedAgent
        ? selectedAgent?.user?.accountNumbers
        : this.accountNumbers;
    },

    getWalletName(wallet) {
      if (wallet.agent?.user) {
        return `${wallet.agent?.user.lastName} ${wallet.agent?.user.firstName} (${
          wallet.account?.number ?? wallet?.number
        })`;
      }
      const index = this.agents.findIndex((t) => t.id === wallet.idOfAgent);
      if (index !== -1) {
        const data = this.agents[index];
        return `${data?.user.lastName} ${data?.user.firstName} (${
          wallet.account?.number ?? wallet?.number
        })`;
      } else {
        return wallet.accountName ?? wallet?.id;
      }
    },
  },

  mounted() {
    this.loadFromStore();
    this.doesLoadingOpen = false;
  },

  watch: {
    doesAddOpen: function () {
      this.errors = [];
      if (!this.doesAddOpen) {
        this.initData(null);
      }
    },
    doesEditOpen: function () {
      this.errors = [];
      if (!this.doesEditOpen) {
        this.initData(null);
        this.account = null;
      }
    },
    doesDeleteOpen: function () {
      if (!this.doesDeleteOpen) {
        this.initData(null);
        this.account = null;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="hstack mb-3" v-show="status !== 403">
      <b-button variant="primary" @click="refresh()" class="ms-auto">
        <i class="bx bx-refresh font-size-16 align-middle me-2"></i>
        Refresh
      </b-button>
      <b-button variant="primary" @click="onAddItem()" class="ms-1">
        <i class="bx bx-plus font-size-16 align-middle me-2"></i>
        Ajouter un nouveau
      </b-button>
    </div>

    <div class="row mb-4">
      <div class="col-md-4">
        <input
          type="search"
          class="form-control"
          v-model="search"
          v-on:input="filter_account()"
          placeholder="Rechercher"
        />
      </div>
    </div>

    <div class="row" v-show="status !== 403">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listes des accounts</h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des <code>accounts</code>.
            </p>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead>
                  <tr class="bg-light">
                    <th>#</th>
                    <th>Name</th>
                    <th>Number</th>
                    <th>Status</th>
                    <th>Link</th>
                    <th>wallet</th>
                    <th>Depositing</th>
                    <th class="ps-4">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="account in accounts" :key="account.id">
                    <th>1</th>
                    <td>{{ account?.accountName }}</td>
                    <td>{{ account?.number }}</td>
                    <td>{{ account.status }}</td>
                    <td>{{ account.link }}</td>
                    <td>{{ account.wallet?.id }}</td>
                    <td>{{ account.deposit }}</td>
                    <td class="hstack">
                      <b-button
                        class="btn-sm ms-2"
                        @click="initItem(account, 'edit')"
                        variant="success"
                      >
                        <i class="bx bx-edit font-size-16 align-middle mx-1"></i>
                      </b-button>
                      <b-button
                        variant="danger"
                        @click="initItem(account, 'delete')"
                        class="ms-2 btn-sm"
                      >
                        <i class="bx bx-trash font-size-16 align-middle mx-1"></i>
                      </b-button>
                      <router-link :to="'/agents_accounts/' + account.id">
                        <b-button class="btn-sm ms-2 rounded-pill px-2" variant="primary">
                          Details
                        </b-button>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="status === 403">
      <h3 class="text-danger text-center my-5">Réserver à l'administrateur principal</h3>
    </div>

    <!-- LOADING MODAL -->
    <b-modal
      v-model="doesLoadingOpen"
      id="modal-center"
      centered
      size="md"
      title="Chargement..."
      title-class="font-18"
      hide-footer
    >
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>

    <!-- ADD MODAL -->
    <b-modal
      v-model="doesAddOpen"
      id="modal-center"
      centered
      size="lg"
      title="Ajouter un pays"
      title-class="font-18"
      hide-footer
    >
      <form @submit.prevent="addItem()">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="">Sélectionnez l'agent</label>
            <select
              required
              v-model="agent_id"
              @change="updateAccounts()"
              class="form-control"
            >
              <option value=""></option>
              <option v-for="agent in agents" :key="agent.id" :value="agent.id">
                {{ agent.user?.firstName }} {{ agent.user?.lastName }}
              </option>
            </select>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Sélectionnez wallet</label>
            <select required v-model="wallet_id" class="form-control">
              <option value=""></option>
              <option v-for="wallet in wallets" :key="wallet.id" :value="wallet.id">
                {{ getWalletName(wallet) }}
              </option>
            </select>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Sélectionnez le compte</label>
            <select required v-model="account_id" active="" class="form-control">
              <option value=""></option>
              <option
                v-for="compte in selectedAgentAccounts"
                :key="compte.id"
                :value="compte.id"
              >
                {{ compte.number }}({{ compte.method?.name }})
              </option>
            </select>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Status </label>
            <select class="form-control" required v-model="account_status">
              <option value="pending">pending</option>
              <option value="active">active</option>
              <option value="exceeded">exceeded</option>
              <option value="blocked">blocked</option>
            </select>
            <span class="text-danger mt-2" v-if="errors.account_status">{{
              errors.account_status
            }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Account Name</label>
            <input type="text" required v-model="accountName" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.accountName">{{
              errors.accountName
            }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Number</label>
            <input type="text" required v-model="number" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.number">{{ errors.number }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">link</label>
            <input type="url" required v-model="link" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.link">{{ errors.link }}</span>
          </div>
        </div>
        <div class="mt-3" v-if="!loading">
          <input type="submit" value="Enregistrer" class="btn btn-primary" />
        </div>
        <div class="mt-3 text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- EDIT MODAL -->
    <b-modal
      v-model="doesEditOpen"
      id="modal-center"
      centered
      size="lg"
      title="Modifier un account"
      title-class="font-18"
      hide-footer
    >
      <form @submit.prevent="editItem()">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="">Sélectionnez l'agent</label>
            <select required v-model="agent_id" class="form-control">
              <option value=""></option>
              <option v-for="agent in agents" :key="agent.id" :value="agent.id">
                {{ agent.user?.firstName }} {{ agent.user?.lastName }}
              </option>
            </select>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Sélectionnez wallet</label>
            <select required v-model="wallet_id" class="form-control">
              <option value=""></option>
              <option v-for="wallet in wallets" :key="wallet.id" :value="wallet.id">
                {{ getWalletName(wallet) }}
              </option>
            </select>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Sélectionnez le compte</label>
            <select required v-model="account_id" class="form-control">
              <option value=""></option>
              <option
                v-for="compte in selectedAgentAccounts"
                :key="compte.id"
                :value="compte.id"
              >
                {{ compte.number }}({{ compte.method?.name }})
              </option>
            </select>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Status </label>
            <select class="form-control" required v-model="account_status">
              <option :value="true">Activé</option>
              <option :value="false">Desactivé</option>
            </select>
            <span class="text-danger mt-2" v-if="errors.account_status">{{
              errors.account_status
            }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Account Name</label>
            <input type="text" required v-model="accountName" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.accountName">{{
              errors.accountName
            }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Number</label>
            <input type="text" required v-model="number" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.number">{{ errors.number }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">link</label>
            <input type="url" required v-model="link" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.link">{{ errors.link }}</span>
          </div>
        </div>
        <div class="mt-3" v-if="!loading">
          <input type="submit" value="Enregistrer" class="btn btn-primary" />
        </div>
        <div class="mt-3 text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- DELETE MODAL -->
    <b-modal
      v-model="doesDeleteOpen"
      id="modal-center"
      title="Supprimer un account"
      title-class="font-18"
      hide-footer
    >
      <p class="mb-2">
        Voulez-vous vraiment supprimer le account <b>{{ account?.name }}</b> ?
      </p>
      <div class="hstack mt-2" v-if="!loading">
        <button class="btn btn-dark ms-auto" @click="doesDeleteOpen = false">
          Annuler
        </button>
        <button class="ms-3 btn btn-danger" @click="deleteIt()">Supprimer</button>
      </div>
      <div class="text-center" v-else>
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
